/* eslint-disable global-require */
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import 'services/Mocks';
import '@babel/polyfill';
import React from 'react';

import ReactDOM from 'react-dom';
import { store } from './store/createStore';
import AppContainer from './containers/AppContainer';

const MOUNT_NODE = document.getElementById('root');

if (false && process.env.NODE_ENV !== 'production') {
  const { whyDidYouUpdate } = require('why-did-you-update');
  whyDidYouUpdate(React);
}

let render = () => {
  // const routes = require('./routes/index').default(store);

  ReactDOM.render(<AppContainer store={store} withRoute />, MOUNT_NODE);
};

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    const renderApp = render;
    const renderError = error => {
      const RedBox = require('redbox-react').default;
      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (error) {
        renderError(error);
      }
    };

    module.hot.accept('./routes/index.js', () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      }),
    );
  }
}

render();
